import { Alert, Button, Group } from '@mantine/core';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { axiosWrapper } from './utils.ts';

export const Consent = ({ refetch }) => {
    const { mutate, isPending } = useMutation({
        mutationFn: () => axiosWrapper(axios({
            url: `/api/consent`,
            method: 'POST',
        })),
        onSuccess: () => {
            refetch()
        },
    })

    return (
        <Alert color="blue">
            <Group grow>
                <p>To use this application, please consent to us storing the access token to your account in short term memory for this session only. This mail tester will not store any other data, but only present data to the browser directly.</p>
                <Button color="green" onClick={() => mutate()} loading={isPending}>
                    Consent Mail Tester
                </Button>
            </Group>
        </Alert>
    )
}
